import {useContext, useEffect} from 'react';
import {observer} from 'mobx-react';
import {Outlet, useParams, Navigate} from 'react-router-dom';
import {NetworkContext} from '../lib/context';
import {useProviderRosterList} from '../components/hooks/use-provider-roster-list';

type RosterIDParam = {
    rosterId: string
}

export const RosterIDWrapper = observer(function RosterIDWrapper() {
    const {rosterId} = useParams<RosterIDParam>();
    const networkOptimizationStore = useContext(NetworkContext);

    // Loaded through the store, so pages below share this request and its status instead of repeating it
    const {reload: reloadRosters} = useProviderRosterList((error, retry) => {
        networkOptimizationStore.handleApiError(error, 'Failed to Load Roster', retry);
    });

    // Refresh the roster list whenever a roster is opened
    useEffect(() => {
        if (rosterId) {
            reloadRosters();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rosterId]);

    // Read the name from the store: the list may come from a request another component started
    const {providerRosters} = networkOptimizationStore;
    useEffect(() => {
        if (rosterId) {
            networkOptimizationStore.rosterFileName = providerRosters.find((roster: any) => roster.rosterId === rosterId)?.rosterName;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rosterId, providerRosters]);

    // Check for existing streams when runId is set
    useEffect(() => {
        if (rosterId) {
            // Set the runId first
            networkOptimizationStore.runId = Number(rosterId);
            // Then check for existing streams to reconnect
            networkOptimizationStore.checkForExistingStreams();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rosterId]);

    if (!rosterId)
        return <Navigate to="/network-optimization/my-files" replace />;

    return <Outlet />;
});
